// extracted by mini-css-extract-plugin
export default {"typography":"Typography_typography__Ua9mo","p":"Typography_p__6pEug","h1":"Typography_h1__A02uP","h2":"Typography_h2__e-bcP","h3":"Typography_h3__lyQsW"};